import { useCategories } from '../../hooks/useCoupons';

const ICONS = {
  travel: '✈️', retail: '🛍️', dining: '🍽️', 'health-wellness': '💪',
  entertainment: '🎬', 'financial-services': '💳', auto: '🚗', technology: '💻',
  fashion: '👗', beauty: '💄', home: '🏡', grocery: '🛒', default: '🏷️',
};

export default function CategoryFilter({ selected, onChange }) {
  const { categories, loading } = useCategories();
  if (loading) return null;

  return (
    // Desktop keeps the single-line scroll rail. At tablet and below the
    // chips wrap instead (see .category-filter-* in styles.css): on a phone
    // the rail hid most categories off-screen behind a scrollbar, so they
    // were effectively undiscoverable.
    <div className="category-filter-scroll" style={{ overflowX: 'auto', paddingBottom: 6, margin: '0 -4px' }}>
      <div className="category-filter-row" style={{ display: 'flex', gap: 8, minWidth: 'max-content', padding: '0 4px' }}>
        <Pill icon="🔥" label="All Deals" active={!selected} onClick={() => onChange(null)} />
        {categories.map(cat => (
          <Pill
            key={cat.id}
            icon={ICONS[cat.slug] || ICONS.default}
            label={cat.name}
            count={cat.coupons_count}
            active={selected === cat.slug}
            onClick={() => onChange(cat.slug === selected ? null : cat.slug)}
          />
        ))}
      </div>
    </div>
  );
}

function Pill({ icon, label, count, active, onClick }) {
  return (
    <button
      onClick={onClick}
      style={{
        display: 'flex', alignItems: 'center', gap: 8, padding: '9px 18px',
        borderRadius: 999,
        border: active ? '1.5px solid transparent' : '1.5px solid #E4E7F0',
        background: active ? 'var(--brand-gradient)' : '#fff',
        color: active ? '#fff' : '#4A5568',
        fontSize: 13, fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap',
        transition: 'all 0.15s', fontFamily: 'inherit',
        boxShadow: active ? 'var(--shadow-glow)' : 'none',
      }}
      onMouseEnter={e => { if (!active) { e.currentTarget.style.background = '#F7F8FC'; e.currentTarget.style.borderColor = '#D8C8F8'; } }}
      onMouseLeave={e => { if (!active) { e.currentTarget.style.background = '#fff'; e.currentTarget.style.borderColor = '#E4E7F0'; } }}
    >
      <span style={{ fontSize: 15 }}>{icon}</span>
      <span>{label}</span>
      {count !== undefined && count > 0 && (
        <span style={{ fontSize: 11, fontWeight: 700, background: active ? 'rgba(255,255,255,0.22)' : '#F0F2F8', color: active ? '#fff' : '#8B94A8', borderRadius: 999, padding: '2px 8px' }}>
          {count}
        </span>
      )}
    </button>
  );
}
